<template>
  <div>
    <div class="my-message all-order-content" v-if="!serviceMsg">
      <div class="breadcrumb" style="margin-bottom: 20px;">个人信息</div>
      <div class="right-content">
        <el-form ref="serviceForm" label-width="160px" :model="serviceForm" :rules="rules" class="demo-form-inline">
          <el-form-item label="客服昵称：" prop="name">
            <el-input v-model="serviceForm.name" placeholder="请输入昵称" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属平台：" prop="relationId"> {{ serviceForm.platformCode }} </el-form-item>
          <el-form-item label="平台名称：" prop="relationId"> {{ serviceForm.platformName }} </el-form-item>
          <el-form-item label="客服头像：" prop="serviceUrl">
            <el-upload ref="uploadFile" :class="{ hide_uploadbtn: serviceForm.serviceUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg' :on-preview="showAppImagePreview('ban')"
              :on-remove="(e) => removeAppImage(e, 'ban')" :file-list="serviceForm.serviceUrl" :http-request="(e) => uploadAppImage(e, 'ban')" :multiple="false" :limit="1">
              <i class="el-icon-plus"></i>
            </el-upload>
            <p style="color: #999;line-height: 22px;">15M之内JPG或PNG图片</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="openChatWindow" round>确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-else style="width: 100%;height: 500px;padding-top: 250px;text-align: center;font-weight: bolder;font-size: 22px;color: #888888">

      当前正与客户聊天中，请勿关闭聊天网页可切换左侧菜单查询订单 （或进入<span style="">聊天网页</span>）
    </div>
  </div>
</template>

<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { bindCustomer } from '@/api/crm'
import { resolve } from 'path'
export default {
  name: 'service-index',
  data () {
    return {
      serviceMsg: null,
      serviceForm: {
        name: '',
        platformCode: this.$store.state.user.storeCode,
        platformName: this.$store.state.user.storeName,
        serviceUrl: [],
        userId: localStorage.getItem('userId')
      },
      tableDataList: []
    }
  },
  async created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    this.serviceMsg = this.$store.state.user.serviceMsg
    if (this.serviceMsg) {
      // 打开聊天室页面
      const href = this.$router.resolve({
        path: '/app/chatWindow',
        query: { key: 1, awsSdk: JSON.stringify(this.$store.state.awsSdk.product.s3) }
      }).href
      // 打开新的页面 到 href 这个页面
      window.open(href, '_blank')
    }
  },
  methods: {
    openChatWindow () {
      if (!this.serviceForm.name) {
        this.$message.error('请输入客服昵称')
        return
      }
      if (!this.serviceForm.serviceUrl[0]?.url) {
        this.$message.error('请上传客服头像')
        return
      }
      let parames = {
        ...this.serviceForm,
        imageUrl: this.serviceForm.serviceUrl[0]?.url || ''
      }
      delete parames.serviceUrl
      bindCustomer(parames).then(res => {
        console.log('res', res)
        if (res.data.success) {
          // 打开聊天室页面
          const href = this.$router.resolve({
            path: '/app/chatWindow',
            query: { key: 1, awsSdk: JSON.stringify(this.$store.state.awsSdk.product.s3) }
          }).href
          // 打开新的页面 到 href 这个页面
          window.open(href, '_blank')
          this.serviceMsg = res.data.data
          this.$store.commit('user/userServiceMsg', res.data.data)
        }
      })
    },
    // async getBannerDetail (bannerId) {
    //   await getBannerInfoById(bannerId).then(res => {
    //     if (res.data.success) {
    //       this.serviceForm = res.data.data
    //       this.serviceForm.serviceUrl = res.data.data.serviceUrl ? [{ url: res.data.data.serviceUrl }] : []
    //       if (res.data.data.detailsUrl) {
    //         this.serviceForm.detailsUrl = res.data.data.detailsUrl.split(',').map(a => {
    //           return {
    //             url: a
    //           }
    //         })
    //       } else {
    //         this.serviceForm.detailsUrl = []
    //       }
    //       console.log(' this.serviceForm.', this.serviceForm)
    //     }
    //   })
    // },
    // 上传产品phone端详情图片
    uploadPhoneDetailImg (e) {
      if (e.file.type !== 'image/jpeg' && e.file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        // 获取富文本组件实例
        let quill = this.$refs.phoneQuillEditor.quill
        // 如果上传成功
        if (res) {
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res)
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      })
    },
    removeAppImage (val, type) {
      console.log('removeAppImage', val)
      if (type == 'ban') {
        this.serviceForm.serviceUrl = []
      } else if (type == 'banDetail') {
        // this.serviceForm.serviceUrl = []
        this.serviceForm.detailsUrl = this.serviceForm.detailsUrl.filter(a => a.uid !== val.uid)
        console.log('serviceForm.detailsUrl', this.serviceForm.detailsUrl)
      }
      // this.serviceForm.serviceUrl = ''
    },
    showAppImagePreview (type) {
      this.showImgPreview = true
      this.previewImage = this.serviceForm.serviceUrl
    },
    uploadAppImage (e, type) {
      console.log('e', e)
      if (e.file.size > 1024 * 1024 * 15) {
        // 清空默认展示的图片
        console.log('this.$refs.uploadFile', this.$refs.uploadFile)
        this.$refs.uploadFile.uploadFiles = []
        this.$message.error('图片大小不能超过15M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          if (type == 'ban') {
            this.serviceForm.serviceUrl.push({ url: res })
          }
          if (type == 'banDetail') {
            console.log('res', res)
            this.serviceForm.detailsUrl.push({ url: res })
          }
          this.showPcImage = false
          this.$refs.serviceForm.validateField('serviceUrl')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    }
    // saveBanner () {
    //   console.log(this.serviceForm.serviceUrl)
    //   if (this.serviceForm.serviceUrl.length < 1) {
    //     this.$message.error('请上传banner图片！')
    //     return
    //   }
    //   let detailsUrl = this.serviceForm.detailsUrl?.map(a => {
    //     return a.url
    //   })
    //   this.serviceForm.detailsUrl = detailsUrl.toString()
    //   this.serviceForm.serviceUrl = this.serviceForm.serviceUrl[0]?.url || ''
    //   if (!this.serviceForm.id) {
    //     appBannerSave(this.serviceForm).then(res => {
    //       if (res.data.success) {
    //         this.$notify({
    //           title: '成功',
    //           message: '保存成功',
    //           type: 'success'
    //         })
    //         this.$router.go(-1)
    //       }
    //     }
    //     )
    //   } else {
    //     delete this.serviceForm.updateTime
    //     delete this.serviceForm.createTime
    //     updateBannerById(this.serviceForm).then(res => {
    //       if (res.data.success) {
    //         if (res.data.success) {
    //           this.$notify({
    //             title: '成功',
    //             message: '保存成功',
    //             type: 'success'
    //           })
    //           this.$router.go(-1)
    //         }
    //       }
    //     })
    //   }
    // }
  },
  beforeDestroy () {
    console.log('刷新')
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
